<template>
  <div
    ref="contentModal"
    aria-hidden="true"
    aria-labelledby="contentModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div v-if="guide" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title textStyle">
            {{ guide?.name }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <!-- ST143-TI-17771 (c-group 1, KEEP + SANITIZE): back-office WYSIWYG guide content. -->
          <div v-if="guide.text" v-safe-html="guide.text"></div>
          <a v-if="guide?.file?.pathName" :href="src()" target="_blank">
            {{ $t("download_file") }}
            <FontAwesomeIcon icon="fa-light fa-download" class="ms-2"
          /></a>
          <div v-if="isPicture()"><img :src="setPicture()" :alt="guide?.file?.originalName" class="mt-2" /></div>
          <iframe v-else-if="guide && guide.base64Pdf" :src="guide.base64Pdf" class="pdf mt-2"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pictureManager } from "@/services/utilities/picture-manager";
import { fileManager } from "@/services/file/file-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { modalMixin } from "@/mixins/modalMixin";

export default {
  name: "GuideModalComponent",
  components: { FontAwesomeIcon },
  mixins: [modalMixin],
  props: {
    guide: {
      type: Object,
      required: false,
      default: () => null,
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["hidden"],
  watch: {
    opened() {
      if (this.opened) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
  methods: {
    isPicture() {
      return !!(
        this.guide?.file?.name?.includes(".jpg") ||
        this.guide?.file?.name?.includes(".jpeg") ||
        this.guide?.file?.name?.includes(".png") ||
        this.guide?.file?.name?.includes(".webp") ||
        this.guide?.file?.name?.includes(".gif")
      );
    },

    setPicture() {
      return pictureManager.setPicture(this.guide.file);
    },

    src() {
      return fileManager.getDownloadSrc(this.guide.file);
    },
  },
};
</script>

<style scoped lang="scss">
.indicator__container {
  padding: 10px 10px 0 10px;
  font-size: 15px;
}

.pdf {
  width: 100%;
  height: 500px;
}
</style>
